/* eslint-disable no-console */
/* eslint-disable react/display-name */
import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Grid from "@mui/material/Grid";
import {
  AutoSaveField as Field,
  Input,
  InlineRadioGroup,
  SelectAutocomplete,
  NumberFormat
} from "../../../../components/Form";
import { ContinueButton } from "../../../../components/Buttons/ContinueButton";
import { ContinueBtn, LabelStyle, FormStyle } from "./styled";
import { ScrollToError } from "components/ScrollToError";

const initialValues = {
  noOfAmendments: "",
  allMOAprovided: "",
  yearsInBusiness: "",
  licenseCategory: ""
};

const validationSchema = Yup.object().shape({
  noOfAmendments: Yup.string()
    .nullable()
    .max(3, "Maximum 3 characters allowed"),
  yearsInBusiness: Yup.string()
    .nullable()
    .max(3, "Maximum 3 characters allowed"),
  allMOAprovided: Yup.string(),
  licenseCategory: Yup.string()
});
const FormatDecimalNumberInput = props => <NumberFormat allowNegative={false} {...props} />;
const commonInputProps = {
  inputProps: { tabIndex: 0 },
  inputComponent: FormatDecimalNumberInput
};

/**
 * LicenseInformation component displays and manages the license information form.
 * @param {Object} props
 * @param {Function} props.handleContinue - Callback for form submission.
 */
export const LicenseInformation = ({ handleContinue }) => {
  const roProspectPath = "roProspect.organizationInfoRO";
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnChange={false}
      onSubmit={handleContinue}
    >
      <FormStyle>
        <ScrollToError />
        <Grid container spacing={3}>
          <Grid item sm={6} xs={12}>
            <Field
              name="licenseCategory"
              label="License Category"
              path={`${roProspectPath}.licenseCategory`}
              component={SelectAutocomplete}
              datalistId="licenseCategorySA"
              tabIndex="0"
              isSearchable
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Field
              name="yearsInBusiness"
              label="Number of Years in Business"
              path={`${roProspectPath}.yearsInBusiness`}
              placeholder="Number of Years in Business"
              component={Input}
              InputProps={{
                ...commonInputProps
              }}
            />
          </Grid>
          <Grid item sm={9} xs={12}>
            <Field
              name="noOfAmendments"
              label="Number of amendments since inception"
              placeholder="Number of amendments since inception"
              path={`${roProspectPath}.noOfAmendments`}
              component={Input}
              InputProps={{
                ...commonInputProps
              }}
            />
          </Grid>
          <Grid container item alignItems="center" sm={6} xs={12}>
            <LabelStyle component="p">All MOA or amendments provided?</LabelStyle>
          </Grid>
          <Grid item sm={6} xs={12}>
            <Field
              name="allMOAprovided"
              label=""
              component={InlineRadioGroup}
              path={`${roProspectPath}.allMOAprovided`}
              datalistId="YesNoList"
              typeRadio
              contextualHelpProps={{ isDisableHoverListener: false }}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="flex-end" mt={2}>
          <ContinueBtn>
            <ContinueButton type="submit" />
          </ContinueBtn>
        </Grid>
      </FormStyle>
    </Formik>
  );
};
